// eslint-disable-next-line import/no-cycle
import { getApi } from '@/shared/api';
import { useStorage } from '@vueuse/core';
// import router from '@/app/router';
import { getCookie } from '@/shared/lib/helpers/cookies';
// import router from '@/app/router';

export default {
	namespaced: true,
	state: () => ({
		sbpPayment: true,
		prolongation: {
			endmax: false,
			prolongationModal: useStorage('prolongationModal', ''),
			prolongationMessage: getCookie('prolongation-msg'),
		},
		paymentContractStatus: {
			// endTimeStatusCheck: useStorage('endTimeStatusCheck', ''),
			contractClosed: useStorage('contractClosedStatus', ''),
		},
	}),
	mutations: {
		HIDE_SBP_PAYMENT(state) {
			state.sbpPayment = false;
		},
		SHOW_SBP_PAYMENT(state) {
			state.sbpPayment = true;
		},
		SET_PROLONGATION_ENDMAX(state, val) {
			state.prolongation.endmax = val;
		},
		SET_PROLONGATION_MESSAGE(state, message) {
			state.prolongation.prolongationMessage = message;
		},
		SET_CONTRACT_CLOSED_STATUS(state, val) {
			state.paymentContractStatus.contractClosed = val;
		},
	},
	actions: {
		// eslint-disable-next-line no-empty-pattern
		async pay(_, sum) {
			const response = await getApi(`/k5/v1/payment-card/get-url-for-payment?sum=${sum}`);
			return response;
		},
		// eslint-disable-next-line no-empty-pattern
		async paySbp({ }, sum) {
			const response = await getApi(`/k5/v1/payment-sbp/get-url-for-payment?sum=${sum}`);
			return response;
		},
		async checkProlongation({ commit }) {
			try {
				const response = await getApi('/k5/v1/contract/check-interest-accrual-rate');
				console.log('checkProlongation response:', response);
				if (response.data.status === true && response.data?.data?.endmax) {
					commit('SET_PROLONGATION_ENDMAX', response.data?.data?.endmax);
					useStorage('prolongationModal', '').value = 'true';
				} else {
					useStorage('prolongationModal', '').value = null;
				}
			} catch (err) {
				console.log('checkProlongation Error:', err);
				useStorage('prolongationModal', '').value = null;
			}
		},
		async checkPayment(_, uid) {
			const response = await getApi(`/k5/v1/payment/payment-status?payment_uid=${uid}`);
			return response;
		},
		// async checkPayment({ commit }, uid) {
		// 	try {
		// 		const response = await getApi(`/k5/v1/payment/payment-status?payment_uid=${uid}`);
		// 		console.log('checkPayment response: ', response);
		//
		// 		if (response.data?.status === true) {
		// 			if (useStorage('endTimeStatusCheck', '').value === '') {
		// 				console.log('Send time to LS');
		// 				const currentTime = new Date();
		// 				useStorage('endTimeStatusCheck', '').value = String(currentTime.setMinutes(currentTime.getMinutes() + 1));
		// 				useStorage('startTimeStatusCheck', '').value = String(currentTime);
		// 			}
		//
		// 			if (response.data?.data?.payment.sync_1c) {
		// 				const status = response.data?.data?.payment?.status;
		// 				const contractClosedStatus = !!response.data?.data?.payment.contract.date_close;
		//
		// 				if (status === true) {
		// 					commit('SET_CONTRACT_CLOSED_STATUS', contractClosedStatus);
		// 					useStorage('endTimeStatusCheck', '').value = null;
		// 					useStorage('startTimeStatusCheck', '').value = null;
		// 					await router.push({ name: 'success-pay' });
		// 				} else {
		// 					await router.push({ name: 'cancel-pay' });
		// 				}
		// 			} else {
		// 				// проверка и сброс таймера
		// 			}
		// 		}
		// 	} catch (err) {
		// 		console.log('checkPayment Error:', err);
		// 	}
		// },
	},
};
